function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import getOr from '../../utils/getOr';
import closest from '../../utils/dom/closest';
import SimpleDropZone from '../../DragNDrop/SimpleDropZone/SimpleDropZone';
import getDisplayName from '../../getDisplayName';
export var FormUIStateContext = React.createContext({});
export var AutoEditContext = React.createContext(false);
var getNested = getOr([]);
var BlueBoxZone = /*#__PURE__*/function (_React$Component) {
  _inherits(BlueBoxZone, _React$Component);
  function BlueBoxZone(props) {
    var _this;
    _classCallCheck(this, BlueBoxZone);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BlueBoxZone).call(this, props));
    _this.handleBodyClicks = function (e) {
      if (_this.containerRef.current.contains(e.target) || closest(e.target, '.fr-popup')) {
        return;
      } else {
        _this.handleClick('');
      }
    };
    _this.handleClick = function (id) {
      _this.setActive(id);
    };
    _this.handleDoubleClick = function (id) {
      _this.setState(BlueBoxZone.makeEditing(id));
    };
    _this.handleMouseEnter = function (id) {
      clearTimeout(_this.hoverTimeout);
      _this.hoverTimeout = setTimeout(function () {
        return _this.setState(BlueBoxZone.makeHover(id));
      }, 125);
    };
    _this.handleMouseLeave = function (id) {
      clearTimeout(_this.hoverTimeout);
      // Without a timeout this causes a race condition in IE: selecting something from the add field ddl
      // could cause a mouse leave if the option extended beyond the blue box zone.  If this change fires
      // first react-jsonschema-form will overwrite it's state with the stale formData props passed down.
      _this.hoverTimeout = setTimeout(function () {
        return _this.setState(BlueBoxZone.makeNotHover(id));
      }, 125);
    };
    _this.handleFocus = function (id) {
      _this.setActive(id);
    };
    _this.handleBlur = function (id) {
      _this.setState(BlueBoxZone.removeActive);
    };
    _this.setError = function (id) {
      _this.setState(BlueBoxZone.setError(id));
    };
    _this.setActive = function (id) {
      _this.setState(BlueBoxZone.makeActive(id));
    };
    _this.setEditing = function (id) {
      _this.setState(BlueBoxZone.makeEditing(id));
    };
    _this.onDragStart = function (start) {
      _this.setState(BlueBoxZone.setDragging(start.draggableId));
    };
    _this.onDragEnd = function (result) {
      _this.setState(BlueBoxZone.setNotDragging(result.draggableId));
    };
    _this.getItems = function (items) {
      var getter = _this.props.getter;
      if (getter) {
        return getNested(getter)(items);
      } else {
        return items;
      }
    };
    _this.containerRef = React.createRef();
    _this.hooks = {
      onClick: _this.handleClick,
      onMouseEnter: _this.handleMouseEnter,
      onMouseLeave: _this.handleMouseLeave,
      onDoubleClick: _this.handleDoubleClick,
      onFocus: _this.handleFocus,
      onBlur: _this.handleBlur,
      setActive: _this.setActive,
      setEditing: _this.setEditing,
      setError: _this.setError
    };
    _this.state = {
      states: {}
    };
    return _this;
  }
  _createClass(BlueBoxZone, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('click', this.handleBodyClicks, false);
      if (this.props.autoEdit) {
        var items = this.getItems(this.props.items);
        if (items.length === 1) {
          this.setState(BlueBoxZone.makeEditing(items[0].id));
          if (this.props.onEditStateChange) {
            this.props.onEditStateChange(this.state.states);
          }
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevItems = this.getItems(prevProps.items);
      var newItems = this.getItems(this.props.items);

      /**
       * Originally this if block would only be triggered
       * when initially adding a new field
       * With the introduction of the "insert form" functionality
       * when you are inserting a form, the first element that is inserted would
       * end up being in edit mode
       *
       * To get around this, we only care about going into edit mode
       * when the field that's added has the "add field" or "insert form" widget
       * or if the field is a text section
       */
      if (prevItems.length + 1 === newItems.length) {
        var prevIds = prevItems.map(function (obj) {
          return obj.id;
        });
        var newOne = newItems.filter(function (item) {
          return !prevIds.includes(item.id);
        })[0].id;
        if (newOne) {
          var newOneWidget = getNested(['items', "".concat(newOne), 'ui:widget'])(this.props);
          var newOneIsText = !!newItems.find(function (item) {
            return item.id === newOne && item.type === 'text';
          });
          newOne = newOneWidget === 'addField' || newOneWidget === 'insertForm' || newOneIsText ? newOne : '';
        }
        this.setState(BlueBoxZone.makeEditing(newOne));
      }
      if (this.props.onEditStateChange) {
        this.props.onEditStateChange(this.state.states);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.hoverTimeout);
      document.body.removeEventListener('click', this.handleBodyClicks);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        children = _this$props.children,
        items = _this$props.items,
        getter = _this$props.getter,
        idAttribute = _this$props.idAttribute,
        onUpdateOrder = _this$props.onUpdateOrder,
        isDropDisabled = _this$props.isDropDisabled;
      return /*#__PURE__*/React.createElement("span", {
        ref: this.containerRef
      }, /*#__PURE__*/React.createElement(SimpleDropZone, {
        items: items,
        getter: getter,
        idAttribute: idAttribute,
        onUpdateOrder: onUpdateOrder,
        onDragStart: this.onDragStart,
        onDragEnd: this.onDragEnd,
        isDropDisabled: isDropDisabled
      }, function (_ref) {
        var items = _ref.items,
          idAttribute = _ref.idAttribute;
        return /*#__PURE__*/React.createElement(FormUIStateContext.Provider, {
          value: {
            state: _this2.state.states,
            hooks: _this2.hooks,
            items: items,
            idAttribute: idAttribute
          }
        }, children);
      }));
    }
  }]);
  return BlueBoxZone;
}(React.Component);
BlueBoxZone.removeActive = function (_ref2, props) {
  var states = _ref2.states;
  return {
    states: _objectSpread({}, states, {
      active: ''
    })
  };
};
BlueBoxZone.makeActive = function (id) {
  return function (_ref3, props) {
    var states = _ref3.states;
    if (states.error) {
      return;
    }
    return {
      states: _objectSpread({}, states, {
        // edit: '',
        active: id
      })
    };
  };
};
BlueBoxZone.makeEditing = function (id) {
  return function (_ref4, props) {
    var states = _ref4.states;
    if (states.error) {
      return;
    }
    if (id === '') {
      return {
        states: _objectSpread({}, states, {
          edit: id
        })
      };
    } else {
      return {
        states: _objectSpread({}, states, {
          active: '',
          edit: id
        })
      };
    }
  };
};
BlueBoxZone.setError = function (id) {
  return function (_ref5, props) {
    var states = _ref5.states;
    return {
      states: _objectSpread({}, states, {
        active: '',
        edit: id,
        error: id
      })
    };
  };
};
BlueBoxZone.makeHover = function (id) {
  return function (_ref6, props) {
    var states = _ref6.states;
    if (states.error) {
      return;
    }
    return {
      states: _objectSpread({}, states, {
        hover: id
      })
    };
  };
};
BlueBoxZone.makeNotHover = function (id) {
  return function (_ref7, props) {
    var states = _ref7.states;
    return {
      states: _objectSpread({}, states, {
        hover: ''
      })
    };
  };
};
BlueBoxZone.setDragging = function (id) {
  return function (_ref8, props) {
    var states = _ref8.states;
    return {
      states: _objectSpread({}, states, {
        dragging: true,
        active: id
      })
    };
  };
};
BlueBoxZone.setNotDragging = function (id) {
  return function (_ref9, props) {
    var states = _ref9.states;
    return {
      states: _objectSpread({}, states, {
        dragging: false,
        active: id // id of what was being dragged
      })
    };
  };
};
export { BlueBoxZone as default };
export function withBlueBoxZone(WrappedComponent) {
  var _Class;
  return _Class = /*#__PURE__*/function (_React$Component2) {
    _inherits(_Class, _React$Component2);
    function _Class() {
      _classCallCheck(this, _Class);
      return _possibleConstructorReturn(this, _getPrototypeOf(_Class).apply(this, arguments));
    }
    _createClass(_Class, [{
      key: "render",
      value: function render() {
        var props = this.props;
        return /*#__PURE__*/React.createElement(AutoEditContext.Consumer, null, function (autoEdit) {
          return /*#__PURE__*/React.createElement(BlueBoxZone, {
            items: props.uiSchema,
            getter: "dm:layout",
            idAttribute: "id",
            autoEdit: autoEdit,
            onEditStateChange: props.formContext.onEditStateChange,
            onUpdateOrder: props.formContext.onUpdateUISchema,
            isDropDisabled: !props.formContext.isRearrangeable
          }, /*#__PURE__*/React.createElement(WrappedComponent, props));
        });
      }
    }]);
    return _Class;
  }(React.Component), _Class.displayName = "WithBlueBoxZone(".concat(getDisplayName(WrappedComponent), ")"), _Class;
}